var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.condition.meta==='condition')?_c('view-condition',{attrs:{"condition":_vm.condition,"type":_vm.type}}):_vm._e(),(_vm.condition.meta==='block')?_c('view-conditions-block',{attrs:{"block":_vm.condition}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }